import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PreferenceService {

    static getPreference(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPreference}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addPreference(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updatePreference}`;
        return axiosInstance
            .post(api, data)

    }

    static searchProfile(item = {}) {
        let api = `${API_BASE_URL}${API_PATHS.searchProfile}`;

        const params = new URLSearchParams();

        // Pagination
        if (item.page !== undefined) params.append("page", item.page);
        if (item.limit !== undefined) params.append("limit", item.limit);

        // Basic
        if (item.id) params.append("id", item.id);
        if (item.usertype) params.append("usertype", item.usertype);
        if (item.search) params.append("search", item.search);

        // Filters
        if (item.gender) params.append("gender", item.gender);

        if (item.minAge) params.append("minAge", item.minAge);
        if (item.maxAge) params.append("maxAge", item.maxAge);

        if (item.minHeight) params.append("minHeight", item.minHeight);
        if (item.maxHeight) params.append("maxHeight", item.maxHeight);

        if (item.religion) params.append("religion", item.religion);
        if (item.caste) params.append("caste", item.caste);


        if (item.education) params.append("education", item.education);
        if (item.occupation) params.append("occupation", item.occupation);
        if (item.location) params.append("location", item.location);

        if (item.sort) params.append("sort", item.sort);

        const query = params.toString();
        if (query) {
            api += `?${query}`;
        }

        return axiosInstance.get(api);
    }

    static getProfileById(item) {

        let api = `${API_BASE_URL}${API_PATHS.getProfileById}`;

        const params = new URLSearchParams();

        if (item?.id) params.append("id", item.id);


        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getPreferredMatches(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPreferredMatches}`;

        return axiosInstance.get(api, item);
    }

    static viewContact(item) {

        let api = `${API_BASE_URL}${API_PATHS.viewContact}`;


        return axiosInstance.post(api, item);
    }





}

export default PreferenceService;
